module.exports = __webpack_public_path__ + "img/regular_lease_process06.f8949faa.png";